import { configureStore } from '@reduxjs/toolkit'

import rootReducer from './rootReducer'
import { api as foresightApi } from './foresight/core/api/graphql/forshawGraphqlApi.generated'
import { forshawRestApi } from './foresight/core/api/rest/forshawRestApi'
import { replenishmentPlanListenerMiddleware } from './foresight/data/replenishmentPlan/slice/replenishmentPlan.slice'

const store = configureStore({
  reducer: rootReducer,
  devTools: { trace: true, traceLimit: 25 },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat([
      foresightApi.middleware,
      forshawRestApi.middleware,
      replenishmentPlanListenerMiddleware.middleware,
    ]),
})

// tslint:disable: whitespace — tslint 5 can't parse import.meta
if (import.meta.hot) {
  import.meta.hot.accept('./rootReducer', (mod) => {
    if (mod) store.replaceReducer(mod.default)
  })
}
// tslint:enable: whitespace

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
